<template>
  <div style="display: inline-block" class="mr-3 flex-grow-0 flex-shrink-1">
    <v-btn
        color="red white--text"
        x-small fab
        :loading="loading"
        @click="prev"
    >
      <v-icon>undo</v-icon>
    </v-btn>
  </div>
</template>

<script>

import OrderProvider from "@/modules/delivery/providers/OrderProvider";

export default {
  name: "OrderPrevDrinkFlowState",
  props: {
    order: {type: Object},
  },
  data() {
    return {
      loading: false
    }
  },

  methods: {
    async prev() {
      try {
        this.loading = true

        if(this.order.drinkState === 'SERVED'){
          await this.updateOrderDrinkState('WAITING')
          this.order.drinkState = 'WAITING'
          this.$emit("orderUpdated",this.order)
        }

      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async updateOrderDrinkState(drinkState) {
      return await OrderProvider.updateOrderDrinkState({id: this.order.id, drinkState: drinkState})
    }
  }
}
</script>

<style scoped>

</style>
